import { dynamicRouterMap, basicRouterMap } from '../../router'
import store from '@/store'
import Layout from '@/layout'

/**
 * 通过meta.permission判断是否与当前用户权限匹配
 * @param route
 */
function hasPermission(route) {
  if (
    route.meta &&
    route.meta.permissions &&
    route.meta.permissions.length > 0
  ) {
    for (let i = 0; i < route.meta.permissions.length; i++) {
      const permission = route.meta.permissions[i]
      if (store.getters.permissions.has(permission)) return true
    }
    return false
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes dynamicRouterMap
 */
function filterAsyncRouter(routes) {
  const res = []
  routes.forEach((route) => {
    const tmp = { ...route }
    if (hasPermission(tmp)) {
      if (tmp.meta && tmp.meta.matchTitle) {
        // 按照权限来对应导航的名字
        for (let key in tmp.meta.matchTitle) {
          if (store.getters.permissions.has(key)) {
            tmp.meta.title = tmp.meta.matchTitle[key]
            break
          }
        }
      }
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children)
        if (tmp.children.length > 0) {
          res.push(tmp) // 至少有一个子项有权限的时候可以访问
        }
      } else {
        res.push(tmp)
      }
    }
  })

  return res
}

const permission = {
  state: {
    routers: [
      {
        path: '/index',
        component: () => import('@/layout'),
        children: [
          {
            path: '',
            component: () => import('@/views/index.vue'),
            name: 'index',
            meta: {
              title: '首页',
              icon: 'manageBoard',
              i18n: 'sideBar.index'
            }
          }
        ]
      },
      {
        path: '/mediaScore',
        component: () => import('@/layout'),
        children: [
          {
            path: '',
            component: () => import('@/views/data/mediaScore/index.vue'),
            name: 'MediaScore',
            meta: {
              title: '媒体打分',
              icon: 'histogram',
              i18n: 'sideBar.mediaScore'
            }
          }
        ]
      },
      {
        path: '/weightedScore',
        component: () => import('@/layout'),
        children: [
          {
            path: '',
            component: () => import('@/views/weightedScore/index.vue'),
            name: 'WeightedScore',
            meta: {
              title: '媒体排名',
              icon: 'line chart',
              i18n: 'sideBar.mediaWeightedScore'
            }
          }
        ]
      }
    ],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      // 什么都不做，保持写死的菜单
    }
  },
  actions: {
    GenerateRoutes({ commit }) {
      return new Promise((resolve) => {
        // 什么都不做，直接返回
        resolve()
      })
    }
  }
}

export default permission
export { hasPermission }
